module.exports = __webpack_public_path__ + "static/media/Login_Background.57fdb801.png";